import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { WidgetService } from 'src/app/core/http/web/widget.service';
import { InptMesesComponent } from './components/meses/meses.component';
import { saveDataSearchUtil } from 'src/app/core/services/utilities/saveDataSearchUtil.service';
import { environment as params, environment } from 'src/environments/environment';
import { ReadJSONService } from 'src/app/modules/motores/seguros/services/read-json.service';
import { CityTravelComponent } from './components/city-travel/city-travel.component';
import { RegionesTravelComponent } from './components/regiones-travel/regiones-travel.component';
import { TravelCompositorService } from 'src/app/core/http/web/TravelCompositor.service';

@Component({
  selector: 'app-tours',
  templateUrl: './tours.component.html',
  styleUrls: ['./tours.component.scss']
})
export class ToursComponent {
  @Input() public widgetData: any = null;
  @Input() public isMobile: boolean;
  @ViewChild('city1') public city1: CityTravelComponent;
  @ViewChild('city2') public city2: CityTravelComponent;
  @ViewChild('mes1') public mes1: InptMesesComponent;
  @ViewChild('mes2') public mes2: InptMesesComponent;
  @ViewChild('region1') public region1: RegionesTravelComponent;
  @ViewChild('region2') public region2: ElementRef;

  public countries: any;
  public cities: any;
  public form: FormGroup;
  public submited: boolean;
  urlBaseMJ: any = (<any>params).api.mj;
  urlBaseTComositorMj: string = (<any>params).api.tCompositor.urlMJ;
  constructor(
    private formB: FormBuilder,
    private saveInfoServ: saveDataSearchUtil,
    private servTravel: TravelCompositorService,
  ) {
    this.form = this.formB.group({
      fCountry: ['', []],
      fCity: ['', []],
      fMes: ['', []],
      fRegion: ['', []]
    });
    this.buildForm();
    this.getDestinationCountry();
    this.getDestinationCity();
  }

  getDestinationCity() {
    this.servTravel.getDestinationCity().subscribe( result => {
      if (result.data) {
        this.cities = result.data;
      }
    }, (err) => {
      console.error('Error en servicio de travel compositor :', err);
    });
  }

  getDestinationCountry() {
    this.servTravel.getDestinationCountry().subscribe( result => {
      if (result.data) {
        this.countries = result.data;
      }
    }, (err) => {
      console.error('Error en servicio de travel compositor :', err);
    });
  }
  buildForm() {
    this.form.get('fCountry').valueChanges.subscribe(data => {
      if (typeof data === 'object') {
        this.saveInfoSearchFy('pais', data.name + ' (' + data.code + ')');
        if (document.documentElement.clientWidth < 992) {
          setTimeout(() => {
            this.mes2.checkFocus();
          }, 500);
        } else {
          this.city1.checkFocus();
        }
      }
    });

    this.form.get('fCity').valueChanges.subscribe(data => {
      if (typeof data === 'object') {
        this.saveInfoSearchFy('ciudad', data.name + ' (' + data.code + ')');
        if (document.documentElement.clientWidth < 992) {
          setTimeout(() => {
            this.mes2.checkFocus();
          }, 500);
        } else {
          this.mes1.checkFocus();
        }
      }
    });

    this.form.get('fMes').valueChanges.subscribe(data => {
      if (typeof data === 'object') {
        this.saveInfoSearchFy('mes', data.label);
        if (document.documentElement.clientWidth < 992) {
          this.region2.nativeElement.focus();
        } else {
          this.region1.checkFocus();
        }
      }
    });
  }
  sendData() {
    this.submited = true;
    console.log('Enviando datos a: ', this.urlBaseTComositorMj, this.form.value);
    this.getParamsSelected(this.form.value);
  }

  getParamsSelected(data) {
    let params = [];
    if (typeof data.fCountry === 'object') {
      params.push({key: 'country', value: data.fCountry.code});
    }
    if (typeof data.fCity === 'object') {
      params.push({key: 'destinations', value: data.fCity.code});
    }
    if (typeof data.fMes === 'object') {
      params.push({key: 'month', value: data.fMes.value});
    }
    if (typeof data.fRegion === 'object') {
      params.push({key: 'themes', value: data.fRegion.code});
    }
    this.buildParams(params);
  }

  buildParams(params: any) {
    let url = this.urlBaseTComositorMj;
    if (params.length > 0) {
      url += '?';
      params.forEach((e, i) => {
        url += e.key + '=' + e.value;
        url += (params.length > i + 1) ? '&' : '';
      });
    }
    console.log('Url resultante: ', url);
    // window.location.href = url;
    window.open(url.trim(), '_blank');
  }

  saveInfoSearchFy(key, value) {
    this.saveInfoServ.saveData('Widget tours', key, value);
  }
}
